const { vec4 } = require('glov/common/vmath.js');
const { spritesheetRegister } = require('glov/client/spritesheet.js');
module.exports = {
  name: 'cosmic',
  tiles: {
    anim1: 0,
    anim2: 1,
    anim3: 2,
    anim4: 3,
    anim5: 4,
    floor1: 5,
    floor1b: 6,
    floor2: 7,
    floor2b: 8,
    placeholder: 9,
    stairs_in: 10,
    star1: 11,
    star2: 12,
    star3: 13,
    star4: 14,
    star5: 15,
    star6: 16,
    star7: 17,
    star8: 18,
    star9: 19,
    star10: 20,
    star11: 21,
    terminal1: 22,
    terminal2: 23,
    terminal3: 24,
    terminal4: 25,
    terminal5: 26
  },
  uidata: {
    rects: [
      vec4(8/1024,8/128,40/1024,40/128),
      vec4(56/1024,8/128,88/1024,40/128),
      vec4(104/1024,8/128,136/1024,40/128),
      vec4(152/1024,8/128,184/1024,40/128),
      vec4(200/1024,8/128,232/1024,40/128),
      vec4(248/1024,8/128,280/1024,40/128),
      vec4(296/1024,8/128,328/1024,40/128),
      vec4(344/1024,8/128,376/1024,40/128),
      vec4(392/1024,8/128,424/1024,40/128),
      vec4(440/1024,8/128,464/1024,32/128),
      vec4(480/1024,8/128,512/1024,40/128),
      vec4(528/1024,8/128,560/1024,40/128),
      vec4(576/1024,8/128,608/1024,40/128),
      vec4(624/1024,8/128,656/1024,40/128),
      vec4(672/1024,8/128,704/1024,40/128),
      vec4(720/1024,8/128,752/1024,40/128),
      vec4(768/1024,8/128,800/1024,40/128),
      vec4(816/1024,8/128,848/1024,40/128),
      vec4(864/1024,8/128,896/1024,40/128),
      vec4(912/1024,8/128,944/1024,40/128),
      vec4(960/1024,8/128,992/1024,40/128),
      vec4(8/1024,56/128,40/1024,88/128),
      vec4(56/1024,56/128,88/1024,88/128),
      vec4(104/1024,56/128,136/1024,88/128),
      vec4(152/1024,56/128,184/1024,88/128),
      vec4(200/1024,56/128,232/1024,88/128),
      vec4(248/1024,56/128,280/1024,88/128)
    ]
  },
  FRAME_ANIM1: 0,
  FRAME_ANIM2: 1,
  FRAME_ANIM3: 2,
  FRAME_ANIM4: 3,
  FRAME_ANIM5: 4,
  FRAME_FLOOR1: 5,
  FRAME_FLOOR1B: 6,
  FRAME_FLOOR2: 7,
  FRAME_FLOOR2B: 8,
  FRAME_PLACEHOLDER: 9,
  FRAME_STAIRS_IN: 10,
  FRAME_STAR1: 11,
  FRAME_STAR2: 12,
  FRAME_STAR3: 13,
  FRAME_STAR4: 14,
  FRAME_STAR5: 15,
  FRAME_STAR6: 16,
  FRAME_STAR7: 17,
  FRAME_STAR8: 18,
  FRAME_STAR9: 19,
  FRAME_STAR10: 20,
  FRAME_STAR11: 21,
  FRAME_TERMINAL1: 22,
  FRAME_TERMINAL2: 23,
  FRAME_TERMINAL3: 24,
  FRAME_TERMINAL4: 25,
  FRAME_TERMINAL5: 26
};
spritesheetRegister(module.exports);
